// extracted by mini-css-extract-plugin
module.exports = {"container":"LogicMap_container__2FbL3","title":"LogicMap_title__3E2Df","chartContainer":"LogicMap_chartContainer__3qrZR","footerContainer":"LogicMap_footerContainer__14vfb"};